export const reauthMode = (
  urlParams: { isreauth?: string; emailsignature?: string } | {} | undefined
): boolean => {
  if (urlParams === undefined) return false

  if ('isreauth' in urlParams && urlParams.isreauth === 'true') {
    return true
  }

  if (hasEmailSignature(urlParams)) {
    return true
  }

  return false
}

export const hasEmailSignature = (
  urlParams: { emailsignature?: string } | {} | undefined
): boolean => {
  if (urlParams === undefined) return false

  if ('emailsignature' in urlParams && urlParams.emailsignature !== '') {
    return true
  }

  return false
}
